'use client'

import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconCheck } from '@redteclab/icons'

export const NewsletterSubscribeAdBenefits: FC = () => {
  return (
    <div className="-mb-8 mr-2 mt-9 pl-4 tablet:mb-12">
      <ul className="flex flex-col items-start justify-start gap-2 text-m font-normal text-dark-primary-strong">
        <li className="mb-2.5 flex items-center justify-start">
          <span className="mr-3 flex aspect-square size-8 items-center justify-center rounded-full bg-dark-brand">
            <IconCheck className="size-6 fill-light-primary-strong" />
          </span>
          <p>
            <FormattedMessage id="newsletterBox.benefit.sale" />
          </p>
        </li>
        <li className="mb-3 flex items-center">
          <span className="mr-3 flex aspect-square size-8 items-center justify-center rounded-full bg-dark-brand">
            <IconCheck className="size-6 fill-light-primary-strong" />
          </span>
          <p>
            <FormattedMessage id="newsletterBox.benefit.voucher" />
          </p>
        </li>
        <li className="mb-3 flex items-center">
          <span className="mr-3 flex aspect-square size-8 items-center justify-center rounded-full bg-dark-brand">
            <IconCheck className="size-6 fill-light-primary-strong" />
          </span>
          <p>
            <FormattedMessage id="newsletterBox.benefit.freebies" />
          </p>
        </li>
      </ul>
    </div>
  )
}
